<div
  class="object-overview-fields"
  [ngClass]="{'edit': isEditing}"
>
  <app-overview-title
    [objectView]="objectView"
    [noTitle]="noTitle"
  ></app-overview-title>

  @for (field of fields; track $index) {
    <div
      class="row object-overview-fields__item"
      [ngClass]="{'border': $index < 5}"
    >
      <div class="object-overview-fields__field">
        <div class="object-overview-fields__field-title"><!--overview-field-title-->
          <div class="overview-field-title-content">
            {{field.title}}:
          </div>
        </div>

        <div class="object-overview-fields__field-content"><!--field-content-->
          <app-overview-field
            [overviewField]="field"
            [viewName]="'object-overview'"
            [disableLinks]="disableLinks"
            [toneDownTextColor]="false"
          ></app-overview-field>
        </div>
      </div>
    </div>
  }

  @if (errMsg) {
    <div>
      <span class="error">
        {{ errMsg | translate }}
      </span>
    </div>
  }
</div>
